import { render } from "./LoggedIn.vue?vue&type=template&id=28c933b6&scoped=true"
import script from "./LoggedIn.vue?vue&type=script&lang=js"
export * from "./LoggedIn.vue?vue&type=script&lang=js"

import "./LoggedIn.vue?vue&type=style&index=0&id=28c933b6&scoped=true&lang=css"

import exportComponent from "C:\\8 Extension Folder\\8.0 Extension Folder\\8.02\\SMMPortfolioSite\\photographydays-login\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c933b6"]])

export default __exports__